'use strict';

var GridFlowTypeCogButtonDirective = function GridFlowTypeCogButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-flow-type-cog-button.html'),
    controller: 'GridFlowTypeCogButtonController'
  };
};
GridFlowTypeCogButtonDirective.$inject = [];
module.exports = GridFlowTypeCogButtonDirective;